export const REFRESH_PAGE_INTERVAL = 1000 * 60 * 60 * 4 // 4 hours
export const REFRESH_TOKEN_INTERVAL = 1000 * 60 * 12 // 12 minutes

export enum APP_LANGUAGES {
	EN = 'en',
	SK = 'sk'
}

export const DEFAULT_APP_LANGUAGE = APP_LANGUAGES.SK

export enum NAMESPACE {
	LOC = 'loc',
	PATHS = 'paths'
}

export enum MSG_TYPE {
	INFO = 'INFO',
	ERROR = 'ERROR',
	WARNING = 'WARNING',
	SUCCESS = 'SUCCESS'
}

export enum NOTIFICATION_TYPE {
	MODAL = 'MODAL',
	NOTIFICATION = 'NOTIFICATION'
}

export enum FORM {
	LOGIN = 'LOGIN',
	FORGOT_PASSWORD = 'FORGOT_PASSWORD',
	RESET_PASSWORD = 'RESET_PASSWORD',
	WITHDRAWAL_CREATE = 'WITHDRAWAL_CREATE',
	ONBOARDING = 'ONBOARDING_WELCOME'
}

export enum USER_ROLE {
	EMPLOYEE = 'EMPLOYEE'
}

export enum USERS_CONTRACT_STATUS {
	NONE = 'NONE',
	DRAFT = 'DRAFT',
	SENT = 'SENT',
	EXPIRED = 'EXPIRED',
	COMPLETED = 'COMPLETED',
	VIEWED = 'VIEWED'
}

export enum ACCOUNT_STATE {
	ACTIVE = 'ACTIVE',
	INACTIVE = 'INACTIVE',
	DEACTIVATED = 'DEACTIVATED'
}

export enum WITHDRAWAL_STATE {
	PENDING = 'PENDING',
	APPROVED = 'APPROVED',
	REJECTED = 'REJECTED'
}
